import primaryComponents from "../../../../../components/primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import Icon from "../../../../../assets/icons";
import styles from "./createTransfer.module.scss";
import { v4 as uuidv4 } from "uuid";

const StockTransferModal = ({
  transferData,
  otherTransferInfo,
  storeList,
  isTransfering,
  replicateMissingProducts,
  handleSubmit,
  setMissingProducts,
}) => {
  return (
    <div className="text-center d-flex flex-column">
      <div className={`${globalStyles.cardWithBorder}`}>
        <img
          className="mx-auto mb-2"
          width={80}
          src={Icon.noticeIcon}
          alt="notice"
        />
        <p className="mb-4" style={{ maxWidth: "450px", margin: "auto" }}>
          This product does not exist in the receiving store. Would you like to
          automatically create it?
        </p>

        <div className={styles.cardItem}>
          <p>Transfer Product</p>
          <p>Location</p>
        </div>
        {transferData?.map((item) => (
          <div className={styles.cardItem} key={uuidv4()}>
            <p className="dark--text">{item?.name}</p>
            <p className="dark--text">
              {
                storeList?.find(
                  (store) =>
                    `${store?.id}` ===
                    `${otherTransferInfo.transfer_to_store_id}`,
                )?.name
              }
            </p>
          </div>
        ))}

        <div
          className="d-flex justify-content-between mt-5"
          style={{ gap: "10px", width: "100%" }}
        >
          <div style={{ width: "20%" }}>
            <primaryComponents.Button
              classNames="btn btn--outline w-100"
              onClick={() => setMissingProducts(false)}
            >
              No
            </primaryComponents.Button>
          </div>
          <div style={{ width: "80%" }}>
            <primaryComponents.Button
              classNames="btn btn--primary w-100"
              isDisabled={isTransfering}
              isLoading={isTransfering}
              loadingText={"Adding..."}
              onClick={handleSubmit(replicateMissingProducts)}
            >
              Yes
            </primaryComponents.Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockTransferModal;
